import { Button, Spinner, TextInput } from 'flowbite-react';
import React, { useEffect, useState } from 'react'
import showToast from '../CustomToast/toastHelper';
import client from '../../api/client';
import CustomModal from '../Modal/CustomModal';
import CreatePinModal from '../CreatePinModal/CreatePinModal';

interface SecurityQuestion {
    id: number;
    question: string;
    answer: string
}

interface SecurityQuestionVerificationProps {
    // userId: number;
    otp: string,
    closeAllModals:()=>void
}



const AnswerSecurityQuestions = ({otp, closeAllModals}:SecurityQuestionVerificationProps) => {
    const [securityQuestions, setSecurityQuestions] = useState<SecurityQuestion[]>([]);
    const [selectedQuestion, setSelectedQuestion] = useState<SecurityQuestion | null>(null);
    const [answer, setAnswer] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [openCreatePinModal, setOpenCreatePinModal] = useState<boolean>(false)

    // Fetch user's security questions from backend
    useEffect(() => {
        const fetchSecurityQuestions = async () => {
            try {
                const response = await client.get(`/subsidiary/dashboard/user/security-questions/get`);
                console.log(response);

                setSecurityQuestions(response.data.data);

                // Select a random security question
                if (response.data.data.length > 0) {
                    const randomIndex = Math.floor(Math.random() * response.data.data.length);
                    setSelectedQuestion(response.data.data[randomIndex]);
                }
            } catch (err) {
                console.error("Error fetching security questions", err);
                showToast("Failed to load security questions", "error");
            }
        };

        fetchSecurityQuestions();
    }, []);

    const handleSubmit = async () => {
        if (!answer.trim()) {
            setError("Please provide an answer.");
            return;
        }

        setOpenCreatePinModal(true)


    };
    return (
        <div className="flex flex-col items-center justify-center p-6 w-full max-w-md mx-auto ">
            <h2 className="text-xl font-semibold mb-4">Secret Answer</h2>

            {selectedQuestion ? (
                <>
                    <p className="text-sm text-gray-600 text-center mb-4">
                        Answer the security question to proceed.
                    </p>
                    <p className="text-md font-medium mb-2 text-center">{selectedQuestion.question}</p>

                    <TextInput
                        type="text"
                        placeholder="Enter your answer"
                        value={answer}
                        onChange={(e) => setAnswer(e.target.value)}
                        className="w-full mb-4 text-center text-lg border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
                    />

                    {error && <p className="text-red-500 text-sm mb-2">{error}</p>}

                    <Button disabled={answer==''} onClick={handleSubmit} className="w-full bg-custom-button-green text-white font-semibold py-2 rounded-lg">
                        Next
                    </Button>
                </>
            ) : (
                <p className="text-gray-500 text-sm">Loading security question...</p>
            )}

            <CustomModal dismissible size='md' onClose={() => setOpenCreatePinModal(false)} icon='' show={openCreatePinModal}>
                <CreatePinModal closeAllModals={()=>closeAllModals()} securityQuestionPayload={{questionId:selectedQuestion?.id, answer: answer}} otp={otp} close={() => setOpenCreatePinModal(false)} message='Enter a 4-digit PIN and confirm it to proceed' buttonText='Submit' onSuccess={() => { closeAllModals() }} type='reset' />
            </CustomModal>
        </div>
    )
}

export default AnswerSecurityQuestions



